export const logCodes = (state = {data: [], total: 0}, action) => {
  switch (action.type) {
    case 'LOG_CODES_FETCHED':
      return {
        data: action.data,
        total: action.total
      }
    case 'LOG_CODE_ADDED':
      return {
        data: [...state.data, action.data],
        total: state.total += 1
      }
    case 'LOG_CODE_UPDATED':
      const updatedData = state.data.map(d =>
        d.code === action.data.code
          ? { ...d, description: action.data.description }
          : d
      )
      return {
        data: updatedData,
        total: state.total
      }
    default:
      return state;
  }
}

export const logCodeProviders = (state = {data: [], total: 0}, action) => {
  switch (action.type) {
    case 'LOG_PROVIDERS_FETCHED':
      return {
        data: action.data,
        total: action.total
      }
    case 'PROVIDER_ADDED':
      return {
        data: [...state.data, action.data],
        total: state.total += 1
      }
    case 'PROVIDER_UPDATED':
      const updatedData = state.data.map(d =>
        d.id === action.data.id
          ? { ...d, provider: action.data.provider, section: action.data.section, description: action.data.description }
          : d
      )
      return {
        data: updatedData,
        total: state.total
      }
    default:
      return state;
  }
}